import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';

const initialData = {
  successMsg: null,
  errorMsg: null,
  isLoading: false,
  lookupDetailsData: [],
  addLookupDetailsDataStatus: null,
};

const slice = createSlice({
  name: 'addLookupMaintenance',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchLookupDetailsData: (state, action) => {
      state.lookupDetailsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postLookUPValue: (state, action) => {
      state.addLookupDetailsDataStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetLookUpValue: (state) => {
      state.addLookupDetailsDataStatus = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    resetLookDetailsData: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.lookupDetailsData = [];
    },
  },
});

export default slice.reducer;

export const {
  fetchLookupDetailsData,
  fetchStart,
  fetchError,
  postLookUPValue,
  resetLookUpValue,
  resetLookDetailsData,
} = slice.actions;

export const fetchLookupDetails = (typeCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lookup/find/lookuptypevalues/${typeCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchLookupDetailsData(data?.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postLookUPValueData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/save/lookup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postLookUPValue(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetLookUpValueData = () => {
  return (dispatch) => {
    dispatch(resetLookUpValue());
  };
};
export const resetLookDetails = () => {
  return (dispatch) => {
    dispatch(resetLookDetailsData());
  };
};
